// extracted by mini-css-extract-plugin
module.exports = {"teethTable":"Tooth_teethTable__2tiu4","tabContent":"Tooth_tabContent__3u0MV","active":"Tooth_active__3VLrH","showItem":"Tooth_showItem__26R4f","hideItem":"Tooth_hideItem__2MWK7"};